module.exports = __webpack_public_path__ + "img/qrcode_temp_0.69b87a07.svg";